export default {
    mqtt: {
        host: 'a8kcu267h96in-ats.iot.ap-northeast-1.amazonaws.com',
        region: 'ap-northeast-1'
    }
 }